<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75 15.5H20.25" [attr.stroke]="stroke" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3.75 9.5H20.25" [attr.stroke]="stroke" stroke-linecap="round" stroke-linejoin="round" />
</svg>